module.exports = {
  URL_CONFIG: {
    FUNCTION_URL: process.env.REACT_APP_FUNCTION_URL,
    BASE_URL: process.env.REACT_APP_BASE_URL,
    STORAGE_BUCKET_URL_FOR_GENERATED_REPORT:
      process.env.REACT_APP_REPORT_AUDIT_STORAGE_BUCKET,
  },
};
